module.exports = __webpack_public_path__ + "static/img/link11.223ba23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link11.png
// module id = m2G+
// module chunks = 19